import React, { useContext } from "react";
import { FaHardHat, FaTools, FaTruck, FaMapMarkedAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./const.jpg";

const Construction: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/construction');
    } else {
      navigate('/login', { state: { from: '/booking/construction' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">High Risk Industry</span>
          <h1 className="hero-title">Construction Safety</h1>
          <p className="hero-subtitle">
            Navigating the dynamic hazards of a construction site.
            From excavations to high-voltage lines, stay alert and stay alive.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Fatal Four</h2>
              <p className="article-text">
                OSHA identifies four leading causes of fatalities in construction:
                <ol style={{ paddingLeft: '20px', color: '#ccc', marginTop: '10px', lineHeight: '1.8' }}>
                  <li><strong>Falls:</strong> (33%) Unprotected sides, holes, scaffolds.</li>
                  <li><strong>Struck-By:</strong> (11%) Falling objects, vehicles.</li>
                  <li><strong>Electrocutions:</strong> (8.5%) Overhead lines, tools.</li>
                  <li><strong>Caught-In/Between:</strong> (5.5%) Trench collapses, rotating equipment.</li>
                </ol>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Excavation Safety</h2>
              <p className="article-text">
                Trench collapses happen in seconds. Rules: sloping, benching, shielding, or shoring
                for trenches over 5 feet deep. Ladders must be within 25 feet of workers.
                "Call before you dig" to avoid utility strikes.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Heavy Machinery</h2>
              <p className="article-text">
                Blind spots are massive on excavators and dump trucks. Establish eye contact with operators.
                Stay outside the swing radius. Wear high-visibility vests at all times.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Site Management</h2>
              <p className="article-text">
                A tidy site is a safe site. Debris causes trips and fire hazards. Toolbox talks every morning
                set the safety tone for the day's specific activities.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Site Protocols</h4>
              <ul className="key-list">
                <li><FaMapMarkedAlt className="check-icon" /> Site Orientation</li>
                <li><FaHardHat className="check-icon" /> Mandatory PPE Areas</li>
                <li><FaTruck className="check-icon" /> Traffic Control Plan</li>
                <li><FaTools className="check-icon" /> Tool Inspection</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Certified</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your site meets global safety standards.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Construction;
